import TreeEditorPage from "pages/TreeEditorPage";
import React from "react";

const TreeEditorRoute = () => <TreeEditorPage />;

export default TreeEditorRoute;
